import axiosInstance from "./api_helper";

const unwrap = (response) => response.data?.body ?? response.data;

const zakatService = {
    summary: async ({ dateFrom, asOfDate, nisab }) => {
        const params = {};
        if (dateFrom) params.dateFrom = dateFrom;
        if (asOfDate) params.asOfDate = asOfDate;
        if (nisab !== undefined && nisab !== null && nisab !== "") params.nisab = nisab;

        const response = await axiosInstance.get("/api/zakat/summary", { params });
        return unwrap(response);
    },
};

export default zakatService;
